import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  FiMail,
  FiLock,
  FiEye,
  FiEyeOff,
  FiGlobe,
  FiHelpCircle,
  FiHome,
  FiAlertCircle,
} from 'react-icons/fi';
import { NamedLink } from '../../components';
import { login } from '../../ducks/auth.duck';
import css from './LoginForm.module.css';

const validate = values => {
  const errors = {};
  if (!values.email) errors.email = 'Email is required';
  if (!values.password) errors.password = 'Password is required';
  return errors;
};

const LoginForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { loginInProgress, loginError } = useSelector(state => state.auth);

  const onSubmit = values => {
    dispatch(login(values.email, values.password))
      .then(() => history.push('/'))
      .catch(() => {});
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={css.form}>

        

          {/* Heading */}
          <div className={css.header}>
            <h1>Login to ChinaDolphins</h1>
            <p>Enter your credentials to access your account.</p>
          </div>

          {/* API Error */}
          {loginError && (
            <div className={css.apiError}>
              <FiAlertCircle />
              <span>Invalid email or password. Please try again.</span>
            </div>
          )}

          {/* Email */}
          <div className={css.field}>
            <label>Email Address</label>
            <div className={css.inputBox}>
              <FiMail className={css.icon} />
              <Field name="email">
                {({ input, meta }) => (
                  <>
                    <input
                      {...input}
                      type="email"
                      placeholder="Enter your email address"
                      className={meta.touched && meta.error ? css.inputError : ''}
                    />
                    {meta.touched && meta.error && (
                      <span className={css.fieldError}>{meta.error}</span>
                    )}
                  </>
                )}
              </Field>
            </div>
          </div>

          {/* Password */}
          <div className={css.field}>
            <label>Password</label>
            <div className={css.inputBox}>
              <FiLock className={css.icon} />
              <Field name="password">
                {({ input, meta }) => (
                  <>
                    <input
                      {...input}
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Enter your password"
                      className={meta.touched && meta.error ? css.inputError : ''}
                    />
                    {meta.touched && meta.error && (
                      <span className={css.fieldError}>{meta.error}</span>
                    )}
                  </>
                )}
              </Field>
              <button
                type="button"
                className={css.eye}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          {/* Forgot */}
          <div className={css.forgot}>
            <NamedLink name="PasswordRecoveryPage">Forgot Password?</NamedLink>
          </div>

          {/* Login */}
          <button type="submit" className={css.loginButton} disabled={loginInProgress}>
            {loginInProgress ? 'Logging in…' : 'Login'}
          </button>

          {/* Divider */}
          <div className={css.divider}>
            <span>or</span>
          </div>

          {/* Register */}
          <NamedLink name="SignupPage" className={css.registerButton}>
            <FiHome />
            <span>New to ChinaDolphins? Create an Account</span>
          </NamedLink>

         

        </form>
      )}
    />
  );
};

export default LoginForm;
